/**
 * @file     filterUrlCodec.ts
 * @purpose  Single canonical codec for filter <-> URL serialization over
 *           TraditionalSearchValue. The one seam every surface (grid, map,
 *           navbar modal, landing) parses and serializes through, so the URL
 *           is a lossless projection of the full 18-field filter — no surface
 *           reimplements a narrower parse and silently drops fields.
 */

import { type TraditionalSearchValue } from './searchValue';
import {
  serializeFilters,
  parseFilters,
  hasUrlFilterPresence,
  type QueryLike,
} from './filterFieldRegistry';

export type { QueryLike };

/** Serialize the full filter into browser-URL search params (no paging).
 *  Thin wrapper over the canonical registry. */
export function filtersToSearchParams(f: TraditionalSearchValue): URLSearchParams {
  return serializeFilters(f);
}

/**
 * Parse URL search params back into the full filter. Returns null when the
 * params carry no meaningful filter (so callers can fall back to stored /
 * default state instead of clobbering it with an empty filter).
 */
export function filtersFromQuery(params: QueryLike): TraditionalSearchValue | null {
  const next = parseFilters(params);
  return hasUrlFilterPresence(next) ? next : null;
}
